export default __webpack_public_path__ + "static/media/3000_en.7195a8bb.ods";